module.exports = __webpack_public_path__ + "img/businessScopeImg4.a79f9e62.png";